import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@docorga-v1/docorga-angular';

import { Docorga } from '@docorga-v1/docorga-common';

@Injectable()
export class WldifficultyResource {
  private baseUri = '/prl/wldifficulties';

  constructor(private ApiService: ApiService) {}

  // GET
  findWldifficulties(params: {
    expertizeId: Docorga.interfaces.naturalTypes.NExpertizeObjectId;
  }): Observable<Array<Docorga.interfaces.wlDifficulty.IWldifficultyJson>> {
    return this.ApiService.get(`${this.baseUri}`, params);
  }
}
